import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../store'
import { capitalizeFirstLetter } from '../../../../../utils/capitalizeFirstLetter'
import { ArrowLeftIcon } from '../../../../Icons/ArrowIcons'

type MobileUpperBandProps = {
  title: string
  handleReset: (() => void) | undefined
  handleReturn: () => void
}

const MobileUpperBand = ({ title, handleReset, handleReturn }: MobileUpperBandProps): JSX.Element => {
  const locale = useSelector((state: RootState) => state.localeReducer.locale)
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const isRTL = useSelector((state: RootState) => state.localeReducer.isRTL)

  return (
    <div className='rf-w-full rf-py-4 rf-px-4 rf-flex rf-justify-between rf-items-center rf-border-b rf-border-b-black'>
      <button className='rf-flex rf-flex-row rf-items-center rf-text-size-auto' onClick={handleReturn}>
        <ArrowLeftIcon className='rf-w-8' />
        <div className='rf-ml-1'>{capitalizeFirstLetter(title, locale)}</div>
      </button>
      <div className={`${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'} rf-uppercase rf-text-secondary rf-underline`} onClick={handleReset}>
        {translation.template.reset}
      </div>
    </div>
  )
}

export default MobileUpperBand
